import React, { useEffect, useRef, useState } from 'react';
import Layout from '../../components/layout';
import Header from '../../components/header';
import { URLS } from '../../_config';
import Icon from '../../components/icons';
import { AgGridReact } from 'ag-grid-react';
import { data, useLocation, useNavigate } from 'react-router-dom';
import Drawer from '../../components/Drawer';
import CreateAssets from './_components/createAssets';
import { Dropdown, Menu } from '../../components/Dropdown';
import Button from '../../components/elements/button';
import { useAssetsApi } from '../../store/api/hooks/assetsApiHook';
import Search from '../../components/search';
import moment from 'moment';
import StatusChangeReasonModal from './_components/statusChangeReason.modal';
import { statusChangeDataType } from '../../_common/types';
import { useDialog } from '../../store/api/hooks/dialogHook';
import toast from 'react-hot-toast';
import { DATE_FORMAT, PAGE_SIZE } from '../../_common/constant';
import Pagination from '../../components/pagination';
import { saveAs } from 'file-saver';
import * as XLSX from 'xlsx';
import axios from 'axios';
import { downloadExcel, downloadPDF, getPermissionInfo, showLocalDate } from '../../_common/functions';
import Loader from '../../components/loader';
import { filterConfigType } from '../../_config/types';
import Filters from '../../components/filters';
import { useAssestCategoriesSelector, useAssestClassificationsSelector, useAssestDepartmentsSelector, useAssestGroupsSelector, useAssestStatuesSelector, useAssestSubGroupsSelector, useAssestTypesSelector } from '../../store/selectors/masterSelector';
import { useFacilitiesApi } from '../../store/api/hooks/facilitiesApiHook';
import { titleCell } from '../../components/elements/function';
import MoveAssetModal from './_components/moveAsset.modal';
import AssetStatus from './_components/assetStatus';
import { useUserSelector } from '../../store/selectors/userSelector';

const Assets: React.FC = () => {
    const location = useLocation();
    const loggedinuser: any = useUserSelector();
    const assetsAPI = useAssetsApi();
    const navigate = useNavigate();
    const facilityApi: any = useFacilitiesApi();

    const [currentPage, setCurrentPage] = useState<number>(1);
    const [searchParam, setSearchParam] = useState<string>('');
    const [totalRecords, setTotalRecords] = useState<number>(0);

    const [gridApi, setGridApi] = useState<any>(null);
    const [gridColumnApi, setGridColumnApi] = useState<any>(null);
    const [editData, setEditData] = useState<any>(null);

    const addNewAssetRef: any = React.createRef<HTMLButtonElement>();


    const [statuslist, setstatusList] = useState<any>(null);
    const [facilityoption, setFacilityoption] = useState<any>([]);

    const { confirm } = useDialog();


    const [columnDefs, setColumnDefs] = useState<any[] | null>(null)

    // Define row data
    const [rowData, setRowData] = useState<any>(null)

    const assetsCategories = useAssestCategoriesSelector();
    const assetsDepartments = useAssestDepartmentsSelector();
    const assetsGroups = useAssestGroupsSelector();
    const assetsSubGroups = useAssestSubGroupsSelector();
    const assetsTypes = useAssestTypesSelector();
    const assetsClassifications = useAssestClassificationsSelector();
    const assetsStatues = useAssestStatuesSelector();
    const [copyData, setCopyData] = useState<any>(null);
    const assetRef = useRef<HTMLDialogElement>(null);
    const [assetData, setAssetData] = useState<any>(null);
    const [actionType, setActionType] = useState<"edit" | "duplicate" | 'add' | "convert-to-owned" | null>(null);


    useEffect(() => {
        if (assetsCategories == null) {
            assetsAPI.getAssetCategpry({}, (resp: any) => { }, (error: any) => { });
        }
    }, [assetsCategories]);

    useEffect(() => {
        if (assetsDepartments == null) {
            assetsAPI.getAssetdepartment({pageSize: 5000,
                pageNumber: 1,}, (resp: any) => { }, (error: any) => { });
        }
    }, [assetsDepartments]);

    useEffect(() => {
        if (assetsGroups == null) {
            assetsAPI.getAssetGrouplist({}, (resp: any) => { }, (error: any) => { });
        }
    }, [assetsGroups]);

    useEffect(() => {
        if (assetsSubGroups == null) {
            assetsAPI.getAssetSubGrouplist({}, (resp: any) => { }, (error: any) => { });
        }
    }, [assetsSubGroups]);

    useEffect(() => {
        if (assetsTypes == null) {
            assetsAPI.GetAssetTypeList({}, (resp: any) => { }, (error: any) => { });
        }
    }, [assetsTypes]);

    useEffect(() => {
        if (assetsClassifications == null) {
            assetsAPI.GetAssetClassificationList({}, (resp: any) => { }, (error: any) => { });
        }
    }, [assetsClassifications]);

    useEffect(() => {
        if (assetsStatues == null) {
            assetsAPI.GetAssetStatusList({}, (resp: any) => { }, (error: any) => { });
        }
    }, [assetsStatues]);


    const filtersRef: any = useRef();
    const [filters, setFilters] = useState<any>({});
    const [filtersApplied, setFiltersApplied] = useState<any>({ generalFilter: false, locationFilter: false });
    const [filtersInitialized, setFiltersInitialized] = useState<boolean>(false);

    // Load filters from localStorage on component mount
    useEffect(() => {
        const savedFilters = localStorage.getItem('assetsFilters');
        if (savedFilters) {
            try {
                const parsedFilters = JSON.parse(savedFilters);
                setFilters(parsedFilters);
            } catch (error) {
                console.error('Error parsing saved filters:', error);
                setFilters({});
            }
        } else {
            setFilters({});
        }
        setFiltersInitialized(true);
    }, []);

    // Save filters to localStorage when filters change
    useEffect(() => {
        if (Object.keys(filters).length > 0) {
            localStorage.setItem('assetsFilters', JSON.stringify(filters));
        }
    }, [filters]);
    const filterConfig: filterConfigType[] = [
        { name: 'Name', type: 'text', key: 'assetName' },
        /* { name: 'Asset Category', type: 'dropdown', key: 'assetCategoryIDs', options: assetsCategories ? assetsCategories : [] }, */
        { name: 'Department', type: 'dropdown', key: 'departmentIDs', options: assetsDepartments ? assetsDepartments : [] },
        { name: 'Ownership Type', type: 'dropdown', key: 'accountGroupIDs', options: assetsGroups ? assetsGroups : [] },
        { name: 'Asset Group', type: 'dropdown', key: 'assetSubGroupIDs', options: assetsSubGroups ? assetsSubGroups : [] },
        /* { name: 'Type', type: 'dropdown', key: 'assetTypeIDs', options: assetsTypes ? assetsTypes : [] },
        { name: 'Classification', type: 'dropdown', key: 'assetClassificationIDs', options: assetsClassifications ? assetsClassifications : [] }, */

        { name: 'Status', type: 'dropdown', key: 'statusIDs', options: statuslist ? statuslist : [] },
        //{ name: 'Status', type: 'dropdown', key: 'statusIDs', options: assetsStatues ? assetsStatues : [] },
    ]

    const getfacilitylist = () => {
        const payload = {};
        facilityApi.getFacilityList(
            payload,
            (resp: any) => {
                let facilitylist: any = [];
                resp.facilityList.map((facility: any) => {
                    facilitylist.push({
                        label: facility.facilityName,
                        value: facility.facilityID,
                        data: facility
                    });
                });
                setFacilityoption(facilitylist);
            },
            (error: any) => {
                console.log("error =>", error);
                toast.error(error);
            }
        );
    };




    const onGridReady = (params: any) => {
        setGridApi(params.api);
        setGridColumnApi(params.columnApi);
    };

    const onRowClicked = (event: any) => {
        if (!event.event.target.closest('input[type="checkbox"]')) {
            event.node.setSelected(false); // Unselect row if it's clicked, not by checkbox
        }
    };

    const getSelectedRows = () => {
        const selectedNodes = gridApi?.getSelectedNodes();
        const selectedData = selectedNodes.map((node: any) => node.data);
        return selectedData;
    };

    const onBulkMoveAssets = () => {
        const selectedData = getSelectedRows();
        if (selectedData.length == 0) {
            toast.error("Nothing is selected")
        } else {
            setAssetData(selectedData);
            assetRef.current?.showModal();
        }
    };


    const onBulkExportPdf = () => {
        const selectedData = getSelectedRows();
        const payload: any = {};
        if (selectedData.length > 0) {
            const assetIDs = selectedData.map((asset: any) => asset.assetID).join(',');
            payload.assetIDs = assetIDs;
        }
        assetsAPI.Exportpdf(
            payload,
            (resp: any) => {
                downloadPDF(resp, 'assets')
            },
            (error: any) => {
                console.log("error =>", error);
                toast.error(error);
            }
        );
    };

    const onBulkExportCsv = async () => {
        const selectedData = getSelectedRows();
        const payload: any = {};
        if (selectedData.length > 0) {
            const assetIDs = selectedData.map((asset: any) => asset.assetID).join(',');
            payload.assetIDs = assetIDs;
        }
        assetsAPI.Exportcsv(
            payload,
            (resp: any) => { downloadExcel(resp, 'assets') },
            (error: any) => {
                console.log("error =>", error);
                toast.error(error);
            }
        );
    };

    const onBulkPrintQR = () => {
        const selectedData = getSelectedRows();
        if (selectedData.length == 0) {
            toast.error("Nothing is selected")
        } else {
            let qrAssetList: any = [];
            selectedData?.map((asset: any) => qrAssetList.push({ assetID: asset.assetID, qty: 1 }));
            const payload = { qrAssetList: qrAssetList, assetNameInQR: true };
            assetsAPI.ExportQrCode(payload, (resp: any) => { downloadPDF(resp, 'assets') },
                (error: any) => {
                    console.log("error =>", error);
                    toast.error(error);
                }
            );
        }
    };

    const GetAssetStatusList = () => {
        const payload = {};
        assetsAPI.GetAssetStatusList(
            payload,
            (resp: any) => {
                let deptlist: any = [];
                //console.log("resp.assetStatusList.filter((o:any) => o.isVisible)", resp.assetStatusList.filter((o:any) => o.isVisible))
                resp.assetStatusList.filter((o: any) => o.isVisible).map((facilist: any) => {
                    deptlist.push({
                        label: facilist.statusName,
                        value: facilist.statusID,
                    });
                });
                setstatusList(deptlist);
            },
            (error: any) => {
                console.log("error =>", error);
                toast.error(error);
            }
        );
    };

    const handleActionChange = (e: any, params: any) => {
        const action = e.target.value;
        const rowData = params.data;

        switch (action) {
            case "edit":
                // Implement edit action
                setActionType("edit");
                setEditData(rowData);
                addNewAssetRef.current.open();
                console.log("Edit action for row: ", rowData);
                break;
            case "delete":
                // Implement delete action
                confirm({
                    type: 'delete',
                    title: 'Delete Asset',
                    message: 'Are you sure you want to delete this asset?',
                    onConfirm: () => {
                        assetsAPI.deleteAsset({ assetID: rowData.assetID }, (data: any, msg: any) => {
                            toast.success(msg);
                            getAssetsList();
                        }, (error: any) => {
                            toast.error(error);
                        });
                    }
                });
                break;
            case "duplicate":
                const duplicateData = { ...rowData };
                delete duplicateData.assetID;
                console.log("Duplicate action for row: ", duplicateData);
                setActionType("duplicate");
                setCopyData(duplicateData);
                addNewAssetRef.current.open();
                break;
            case "convert-to-owned":
                console.log("Convert to Owned Asset action for row: ", rowData);
                setActionType("convert-to-owned");
                setCopyData(rowData); // Keep the original assetID for convert-to-owned
                addNewAssetRef.current.open();
                break;
            case "move-asset":
                // Implement move asset action
                console.log("Move Asset action for row: ", rowData);
                setAssetData(rowData);
                assetRef.current?.showModal();
                break;
            case "qr":
                console.log("QR Code action for row: ", rowData);

                const payload = { qrAssetList: [{ assetID: rowData.assetID, qty: 1 }], assetNameInQR: true };
                assetsAPI.ExportQrCode(payload, (resp: any) => { downloadPDF(resp, 'AssetsQr') },
                    (error: any) => {
                        console.log("error =>", error);
                        toast.error(error);
                    }
                );
                break;
            case "schedule-maintenance":
                // Implement schedule maintenance action
                console.log("Schedule Maintenance action for row: ", rowData);
                break;
            default:
                console.log("Unknown action: ", action);
                break;
        }
        e.target.selectedIndex = -1;
    };

    const getAssetsList = () => {
        let payload: any = {
            pageSize: PAGE_SIZE,
            pageNumber: currentPage,
            searchParam: searchParam,

        };
        if (filters) {
            Object.keys(filters).map((key: any) => {
                if (filters[key]) {
                    payload[key] = filters[key];
                }
            });
        }
        if (!payload.hasOwnProperty(`statusIDs`) || (payload.hasOwnProperty(`statusIDs`) && !payload.statusIDs)) {
            payload.statusIDs = [1, 2, 3, 4, 5, 6, 7].join(`,`);
        }
        assetsAPI.getAssetsList(payload, (data: any) => {
            setRowData(data.assetList ? data.assetList : []);
            setTotalRecords(data.totalRecord);
        }, (error: any) => { });
    };

    useEffect(() => {
        getfacilitylist();
        GetAssetStatusList();
    }, []);

    // Call getAssetsList only after filters are initialized
    useEffect(() => {
        if (filtersInitialized) {
            getAssetsList();
        }
    }, [filters, filtersInitialized]);

    useEffect(() => {
        if (statuslist?.length > 0) {
            setColumnDefs([
                { headerCheckboxSelection: true, checkboxSelection: true, width: 50, headerClass: 'bg-[#f0f0f0]' },
                {
                    headerName: 'Asset ID', field: 'assetCode', headerClass: 'bg-[#f0f0f0]', width: 200,
                    cellRenderer: (data: any) => {
                        return (
                            <p className='hover:text-primary font-semibold cursor-pointer' title={data.value}>{data.value}</p>
                        )
                    }, onCellClicked: (param: any) => {
                        navigate(URLS.ASSETS_DETAILS(param.data.assetID));
                    }
                },
                {
                    headerName: 'Asset Name', field: 'name', headerClass: 'bg-[#f0f0f0]', width: 300,
                    cellRenderer: (data: any) => {
                        return (
                            <p className='hover:text-primary font-semibold cursor-pointer' title={data.value}>{data.value}</p>
                        )
                    }, onCellClicked: (param: any) => {
                        navigate(URLS.ASSETS_DETAILS(param.data.assetID));
                    }
                },
                { headerName: 'Asset Group', field: 'assetSubGroupName', headerClass: 'bg-[#f0f0f0]', width: 160, cellRenderer: titleCell },
                { headerName: 'Facility Name', field: 'facilityName', headerClass: 'bg-[#f0f0f0]', flex: 1, minWidth: 160, cellRenderer: titleCell },
                {
                    headerName: 'Status', field: 'statusName', headerClass: 'bg-[#f0f0f0]', width: 200, cellStyle: {
                        alignItems: 'center'
                    }, cellRenderer: (data: any) => {
                        const canChange = getPermissionInfo(location.pathname, "Change Status", loggedinuser);
                        
                        // If status is "Disposed", show the disabled design
                        if (data.data.statusName === "Disposed") {
                            return (
                                <div className={`pointer-events-none cursor-not-allowed flex justify-center h-full flex-col`}>
                                    <div className='flex items-center gap-2 h-full'>
                                        <div className='w-[0.5rem] h-[0.5rem] rounded-full flex-shrink-0' style={{ backgroundColor: data.data.colourCode || '#333333' }}></div>
                                        <select
                                            className="status-dropdown flex-grow"
                                        >
                                            {[{ value: data.data.statusID, label: data.data.statusName }]?.map((status: any) => {
                                                return (
                                                    <option value={status.value} selected={data.data.statusID == status.value}>{status.label}</option>
                                                )
                                            })}
                                        </select>
                                    </div>
                                </div>
                            );
                        }
                        
                        // For all other statuses, show the AssetStatus component
                        return (
                            <AssetStatus
                                asset={data.data}
                                onUpdate={getAssetsList}
                                canChange={canChange}
                            />
                        )
                    }
                },



                {
                    headerName: 'Last Maintenance Date', field: 'lastMaintenanceDate', headerClass: 'bg-[#f0f0f0]', width: 200,
                    cellRenderer: (data: any) => {
                        return (
                            <p className='hover:text-primary font-semibold cursor-pointer'>{showLocalDate(data.value)}</p>
                        )
                    }
                },
                {
                    headerName: 'Warranty Expiry Date', field: 'warrantyEndDate', headerClass: 'bg-[#f0f0f0]', width: 200,
                    cellRenderer: (data: any) => {
                        return (
                            <p className='hover:text-primary font-semibold cursor-pointer'>{showLocalDate(data.value)}</p>
                        )
                    }
                },
                {
                    headerName: "Actions",
                    field: "actions",
                    headerClass: 'bg-[#f0f0f0] text-center',
                    width: 90,
                    pinned: 'right',
                    cellRenderer: (params: any) => {
                        return (
                            <div className='relative h-full w-full flex items-center justify-center'>
                                <Icon name='threedote' size={1.25} className='text-[#000000]' onClick={(e: any) => {
                                    e.stopPropagation();
                                    e.preventDefault();
                                    const dropdown: any = document.querySelector('.action-dropdown');
                                    if (dropdown) {
                                        dropdown.focus();
                                    }
                                    return false;
                                }} />
                                <select
                                    onChange={(e) => {
                                        let action = e.target.value;
                                        if(action === "move-asset"){
                                            action = "Move assets";
                                        }else if(action === "qr"){
                                            action = "Print QR Code";
                                        }else if(action === "convert-to-owned"){
                                            action = "Convert to Owned Asset";
                                        }

                                        if (!getPermissionInfo(location.pathname, action, loggedinuser)) {
                                            toast.error(`You don't have ${action} permission`);
                                            e.target.selectedIndex = -1;
                                            return;
                                        }
                                        handleActionChange(e, params);
                                        //e.target.value = '';
                                    }}
                                    onFocus={(e) => {
                                        e.target.selectedIndex = -1;
                                    }
                                    }
                                    className="action-dropdown"
                                    value={''}
                                    style={{
                                        position: "absolute",
                                        top: 0,
                                        left: 0,
                                        width: "100%",
                                        height: "100%",
                                        opacity: 0,
                                        cursor: "pointer",
                                    }}
                                >
                                    <option value="edit" disabled={!getPermissionInfo(location.pathname, "Edit", loggedinuser)}>Edit</option>
                                    <option value="delete" disabled={!getPermissionInfo(location.pathname, "Delete", loggedinuser)}>Delete</option>
                                    <option value="duplicate" disabled={!getPermissionInfo(location.pathname, "Duplicate", loggedinuser)}>Duplicate</option>
                                    {params.data.assetGroupID === 2 && (
                                        <option value="convert-to-owned">Convert to Owned Asset</option>
                                    )}
                                    <option value="move-asset" disabled={!getPermissionInfo(location.pathname, "Move assets", loggedinuser)}>Move Asset</option>
                                    <option value="qr" disabled={!getPermissionInfo(location.pathname, "Print QR Code", loggedinuser)}>Print QR Code</option>
                                    {/* <option value="schedule-maintenance">Schedule Maintenance</option> */}
                                </select>
                            </div>
                        );
                    },

                }
            ]);
        }
        console.log("statuslist", statuslist);
    }, [statuslist]);

    useEffect(() => {
        if (filtersInitialized) {
            getAssetsList();
        }
        
        const hasActiveFilters = filterConfig.some((filter) => filters[filter.key]);
        const hasActiveLocationFilter = filters?.hasOwnProperty("facilityIDs");
        setFiltersApplied({
            generalFilter: hasActiveFilters,
            locationFilter: hasActiveLocationFilter,
        });
    }, [currentPage, searchParam, filters]);

    // console.log("statuslist", statuslist);
    const createAssetRef: any = useRef();
    return (
        <Layout>
            <Header title='Assets'>
                <Header.Right>
                    <Drawer _ref={addNewAssetRef} isAfterOpenRender={true} onClose={() => {
                        setEditData(null);
                        setCopyData(null);
                        createAssetRef?.current?.reset()
                    }} outsideClose={false} >
                        <Drawer.Button>
                            <Button disabled={!getPermissionInfo(location.pathname, editData ? 'Edit' : 'Add', loggedinuser)}>{editData ? 'Edit' : 'Add New'} Assets</Button>
                        </Drawer.Button>

                        <Drawer.Content title={editData ? 'Edit Assets' : 'Create New Assets'} className='!w-[39.563rem]'>
                            {!getPermissionInfo(location.pathname, "Add", loggedinuser) ? (
                                <div className="p-4 text-red-500">
                                    You don’t have permission to access this form.
                                </div>
                            ) : (
                                <CreateAssets _ref={createAssetRef} editData={editData ? editData : copyData} actionType={actionType} onCreate={() => {
                                    setEditData(null);
                                    setCopyData(null);
                                    getAssetsList();
                                    addNewAssetRef?.current?.close();
                                }} onCancel={() => {
                                    setEditData(null);
                                    setCopyData(null);
                                    getAssetsList();
                                    addNewAssetRef?.current?.close();
                                }} />)}
                        </Drawer.Content>
                    </Drawer>

                    <Dropdown>
                        <Dropdown.Button>
                            <Button theme='secondary'>Bulk Actions</Button>
                        </Dropdown.Button>
                        <Dropdown.Content title='Create New Facility'>
                            <Menu disabled={!getPermissionInfo(location.pathname, "Move assets", loggedinuser)} onClick={onBulkMoveAssets}>Move Assets</Menu>
                            <Menu disabled={!getPermissionInfo(location.pathname, "Export", loggedinuser)} onClick={onBulkExportCsv}>Export excel / csv </Menu>
                            <Menu disabled={!getPermissionInfo(location.pathname, "Export", loggedinuser)} onClick={onBulkExportPdf}>Export pdf</Menu>
                            <Menu disabled={!getPermissionInfo(location.pathname, "Print QR Code", loggedinuser)} onClick={onBulkPrintQR}>Print QR Code</Menu>
                        </Dropdown.Content>
                    </Dropdown>
                </Header.Right>
            </Header>
            <div className='flex items-center justify-between pl-5 pr-3 border-b border-gray-200 h-[3.75rem]'>
                <Pagination
                    perPage={PAGE_SIZE}
                    totalRecords={totalRecords}
                    onPageChange={setCurrentPage}
                    currentPage={currentPage}
                />
                <Search onSearch={setSearchParam} placeholder='Search by name or serial number' />
            </div>
            <div className='bg-[#FAFAFA]'>
                <div className='flex gap-4 px-5 py-2 items-center'>
                    <Button theme='light' onClick={() => filtersRef.current.showModal()}>Filter <Icon name='filter' size={1.40} className={filtersApplied.generalFilter ? "text-blue-700" : ""} /></Button>
                    <Dropdown>
                        <Dropdown.Button>
                            <Button theme='light'><Icon name='grlocation' size={1.20} className={filtersApplied.locationFilter ? "text-blue-700" : ""} /> Location <Icon name='arrowdown' size={1.10} /></Button>
                        </Dropdown.Button>
                        <Dropdown.Content >
                            {facilityoption?.map((facility: any) => {
                                return (
                                    <Menu onClick={() => {
                                        console.log('facility', facility);
                                        setFilters({ ...filters, facilityIDs: [facility.value] })
                                    }}>{facility.label}</Menu>
                                )
                            }
                            )}
                        </Dropdown.Content>
                    </Dropdown>
                    <p className='text-primary font-semibold text-sm cursor-pointer' onClick={() => { 
                        setFilters({});
                        localStorage.removeItem('assetsFilters');
                    }} >Clear Filters</p>
                </div>

                <div className="ag-theme-alpine mx-4  h-1/2">
                    <AgGridReact
                        columnDefs={columnDefs} // Pass columnDefs
                        rowData={rowData || []} // Pass rowData
                        pagination={false}
                        rowSelection="multiple"
                        onGridReady={onGridReady}
                        domLayout="autoHeight"
                        onRowClicked={onRowClicked}
                        loadingOverlayComponent={Loader}
                        noRowsOverlayComponent={() => (
                            <div className="flex items-center justify-center h-full">
                                <div className="text-center text-gray-500">
                                    <div className="text-lg font-medium">No Data Found</div>
                                </div>
                            </div>
                        )}
                    />
                </div>
            </div>

            <Filters _ref={filtersRef} config={filterConfig} filters={filters} onUpdate={setFilters} />
            <MoveAssetModal _ref={assetRef} data={assetData} onUpdate={getAssetsList} />
        </Layout>
    );
};

export default Assets;